/* index.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QpE59%7Bpadding-left%3Avar(--link-picker-padding-left)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbOhNx%7Bpadding-right%3Avar(--link-picker-padding-right)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2YYwB%7Bpadding-top%3Avar(--link-picker-padding-top)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWohXU%7Bpadding-bottom%3Avar(--link-picker-padding-bottom)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPb61cj%7Bdisplay%3Ablock%21important%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138425zaO%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
import React, { type ChangeEvent, type ComponentType, type FormEvent, Fragment, type KeyboardEvent, memo, useCallback, useLayoutEffect, useMemo, useReducer } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMergeRefs } from 'use-callback-ref';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuid } from 'uuid';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { CardClient } from '@atlaskit/link-provider';
import { isSafeUrl, normalizeUrl } from '@atlaskit/linking-common/url';
import { browser } from '@atlaskit/linking-common/user-agent';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled';
import LinkUrl from '@atlaskit/smart-card/link-url';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { useLinkPickerAnalytics, withInputFieldTracking, withLinkPickerAnalyticsContext } from '../../common/analytics';
import { ANALYTICS_CHANNEL } from '../../common/constants';
import type { LinkInputType, LinkPickerProps, LinkSearchListItemData, PickerState } from '../../common/types';
import createEventPayload from '../../common/utils/analytics/analytics.codegen';
import { handleNavKeyDown } from '../../common/utils/handleNavKeyDown';
import { usePlugins } from '../../services/use-plugins';
import { useSearchQuery } from '../../services/use-search-query';
import { Announcer } from './announcer';
import AutoSubmitOnChange from './autoSubmitOnChange';
import { FormFooter, testIds as formFooterTestIds } from './form-footer';
import { LinkPickerSubmitButton } from './form-footer/link-picker-submit-button';
import { formMessages, linkMessages, linkTextMessages, searchMessages } from './messages';
import { SearchResults, testIds as searchTestIds } from './search-results';
import { testIds as textFieldTestIds, TextInput } from './text-input';
import { TrackMount } from './track-mount';
import { getDataSource, getScreenReaderText } from './utils';
const styles = {
  fullWidthSubmitButton: "_3138425zaO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const baseRootContainerStyles = null;
const formFooterMargin = null;
export const testIds: {
  readonly urlError: string;
  readonly clearUrlButton: string;
  readonly linkHelperText: string;
  readonly insertButton: 'link-picker-insert-button';
  readonly cancelButton: 'link-picker-cancel-button';
  readonly actionButton: 'link-picker-action-button';
  readonly submitStatusA11yIndicator: 'link-picker-submit-status-a11y-indicator';
  readonly tabsLoadingIndicator: string;
  readonly tabList: string;
  readonly tabItem: string;
  readonly resultListTitle: string;
  readonly searchResultList: string;
  readonly searchResultLoadingIndicator: string;
  readonly searchResultItem: string;
  readonly searchResultIcon: string;
  readonly emptyResultPage: string;
  readonly searchError: string;
  readonly linkPickerRoot: 'link-picker-root';
  readonly linkPicker: 'link-picker';
  readonly urlInputField: 'link-url';
  readonly textInputField: 'link-text';
} = ({
  linkPickerRoot: 'link-picker-root',
  linkPicker: 'link-picker',
  urlInputField: 'link-url',
  textInputField: 'link-text',
  ...searchTestIds,
  ...formFooterTestIds,
  ...textFieldTestIds
} as const);
const initState: PickerState = {
  url: '',
  displayText: '',
  activeIndex: -1,
  selectedIndex: -1,
  invalidUrl: false,
  activeTab: 0,
  preventHidingRecents: false,
  hasPreview: true
};
function reducer(state: PickerState, payload: Partial<PickerState>): PickerState {
  if (payload.url && state.url !== payload.url) {
    return {
      ...state,
      invalidUrl: false,
      hasPreview: true,
      selectedIndex: isSafeUrl(payload.url) && payload.url.length ? -1 : state.selectedIndex,
      ...payload
    };
  }
  return {
    ...state,
    ...payload
  };
}

/**
 * Bind input fields to analytics tracking
 */
const getLinkFieldContent = (value: string) => {
  if (!Boolean(value)) {
    return null;
  }
  return isSafeUrl(value) ? 'url' : 'text_string';
};
const LinkInputField = withInputFieldTracking(TextInput, 'link', (event, attributes) => ({
  ...attributes,
  linkFieldContent: getLinkFieldContent(event.currentTarget.value)
}));
const DisplayTextInputField = withInputFieldTracking(TextInput, 'displayText');
const client = new CardClient();
export const LinkPicker: ComponentType<LinkPickerProps> = withLinkPickerAnalyticsContext(memo(({
  onSubmit,
  onCancel,
  onContentResize,
  plugins,
  isLoadingPlugins,
  url: initUrl,
  displayText: initDisplayText,
  hideDisplayText,
  featureFlags,
  customMessages,
  isSubmitting = false,
  adaptiveHeight = false,
  moveSubmitButton = false,
  inputRef,
  previewableLinksOnly = false,
  additionalError,
  submitOnInputChange = false,
  recentSearchListSize,
  shouldRenderNoResultsImage,
  alwaysShowTabs,
  disableManualUrlInsert: disableManualUrlInsertProp = false
}: LinkPickerProps) => {
  const disableManualUrlInsert = fg('add-disable-manual-url-capability-technical') && disableManualUrlInsertProp;
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const linkInputRef = React.useRef<HTMLInputElement>(null);
  const mergedRefs = useMergeRefs(inputRef ? [linkInputRef, inputRef] : [linkInputRef]);
  const [state, dispatch] = useReducer(reducer, {
    ...initState,
    url: normalizeUrl(initUrl) || '',
    displayText: initDisplayText || ''
  });
  const {
    activeIndex,
    selectedIndex,
    url,
    displayText,
    invalidUrl,
    activeTab,
    hasPreview
  } = state;
  const intl = useIntl();
  const queryState = useSearchQuery(state);
  const {
    items,
    isLoading: isLoadingResults,
    isActivePlugin,
    activePlugin,
    tabs,
    error,
    retry,
    pluginAction
  } = usePlugins(queryState, activeTab, plugins, recentSearchListSize, alwaysShowTabs);
  const isEditing = !!initUrl;
  const selectedItem: LinkSearchListItemData | undefined = items?.[selectedIndex];
  const isSelectedItem = selectedItem?.url === url;
  const {
    trackAttribute,
    getAttributes
  } = useLinkPickerAnalytics();

  // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
  const submitMessageId = useMemo(() => uuid(), []);
  useLayoutEffect(() => {
    if (onContentResize) {
      onContentResize();
    }
  }, [onContentResize, items, isLoadingResults, isActivePlugin, tabs]);
  const handleChangeUrl = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (isSubmitting) {
      // Prevent changing url while submitting
      return;
    }

    /** Any on change event is triggered by manual input or paste, so source is null */
    trackAttribute('linkFieldContentInputSource', null);
    dispatch({
      url: e.currentTarget.value,
      // If the last action was changing tabs, make sure we're now allowing recents to be hidden
      preventHidingRecents: false
    });
  }, [dispatch, trackAttribute, isSubmitting]);
  const handleChangeText = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    dispatch({
      displayText: e.currentTarget.value
    });
  }, [dispatch]);
  const handleClear = useCallback((field: string) => {
    dispatch({
      activeIndex: -1,
      selectedIndex: -1,
      [field]: '',
      hasPreview: true
    });
  }, [dispatch]);
  const handleUrlClear = useCallback(() => {
    if (isSubmitting) {
      // Prevent clearing url while submitting
      return;
    }
    trackAttribute('linkFieldContentInputSource', null);
    handleClear('url');
  }, [trackAttribute, handleClear, isSubmitting]);
  const handleInsert = useCallback((url: string, title: string | null, inputType: LinkInputType, data?: Record<string, unknown>) => {
    const event = createAnalyticsEvent(createEventPayload('ui.form.submitted.linkPicker', {}));

    // Clone the event so that it can be emitted for consumer usage
    // This must happen BEFORE the original event is fired!
    const consumerEvent = event.clone();
    // Cloned event doesnt have the attributes that are added by
    // the analytics listener in the LinkPickerAnalyticsContext, add them here
    consumerEvent?.update({
      attributes: getAttributes()
    });
    // Dispatch the original event to our channel
    event.fire(ANALYTICS_CHANNEL);
    onSubmit({
      url,
      displayText: displayText || null,
      title: title || null,
      meta: {
        inputMethod: inputType
      },
      data,
      ...(inputType === 'manual' ? {
        rawUrl: state.url
      } : {})
    }, consumerEvent);
  }, [displayText, onSubmit, state.url, createAnalyticsEvent, getAttributes]);
  const handleSelected = useCallback((objectId: string) => {
    if (isSubmitting) {
      // Prevent changing selection while submitting
      return;
    }
    const selectedItem = items?.find(item => item.objectId === objectId);
    if (selectedItem) {
      const {
        url,
        name
      } = selectedItem;
      /**
       * Manually track that the url has been updated using searchResult method
       */
      dispatchEvent(new Event('submit'));
      trackAttribute('linkFieldContent', getLinkFieldContent(url));
      trackAttribute('linkFieldContentInputMethod', 'searchResult');
      trackAttribute('linkFieldContentInputSource', getDataSource(selectedItem, activePlugin));
      handleInsert(url, name, 'typeAhead', {
        ...selectedItem
      });
    }
  }, [handleInsert, trackAttribute, items, activePlugin, isSubmitting]);
  const handleClearInvalidUrl = useCallback(() => {
    dispatch({
      invalidUrl: false
    });
  }, [dispatch]);
  const handleSubmit = useCallback(async (event?: FormEvent<HTMLFormElement>): Promise<void> => {
    event?.preventDefault();
    if (isSubmitting) {
      // Prevent submit while submitting
      return;
    }
    if (isSelectedItem && selectedItem) {
      return handleInsert(selectedItem.url, selectedItem.name, 'typeAhead');
    }
    const normalized = normalizeUrl(url);
    if (normalized) {
      if (previewableLinksOnly) {
        try {
          const urlResponse = await client.fetchData(normalized);
          const responseObject = urlResponse?.data;
          if (responseObject && 'preview' in responseObject) {
            return handleInsert(normalized, null, 'manual');
          } else {
            return dispatch({
              invalidUrl: true,
              hasPreview: false
            });
          }
        } catch {
          return dispatch({
            invalidUrl: true
          });
        }
      } else {
        return handleInsert(normalized, null, 'manual');
      }
    }
    linkInputRef.current?.focus();
    return dispatch({
      invalidUrl: true
    });
  }, [dispatch, handleInsert, isSelectedItem, selectedItem, url, isSubmitting, previewableLinksOnly]);
  const handleTabChange = useCallback((activeTab: number) => {
    dispatch({
      // We don't want any selection to exist after changing tab, as the selection
      // wouldn't mean anything.
      activeIndex: -1,
      selectedIndex: -1,
      // We don't want recents to be hidden, even though we don't have a selection
      preventHidingRecents: true,
      invalidUrl: false,
      hasPreview: true,
      activeTab
    });
    trackAttribute('tab', plugins?.[activeTab]?.tabKey ?? null);
  }, [dispatch, plugins, trackAttribute]);
  const handleSearchListOnChange = (id: string) => {
    if (isSubmitting) {
      // Prevent changing item while submitting
      return;
    }
    const index = items?.findIndex(item => item.objectId === id);
    if (typeof index === 'number') {
      const item = items?.[index];
      if (item) {
        /**
         * Manually track that the url has been updated using searchResult method
         */
        trackAttribute('linkFieldContent', getLinkFieldContent(item.url));
        trackAttribute('linkFieldContentInputMethod', 'searchResult');
        trackAttribute('linkFieldContentInputSource', getDataSource(item, activePlugin));
        dispatch({
          activeIndex: index,
          selectedIndex: index,
          url: item.url,
          invalidUrl: false,
          hasPreview: true
        });
      }
    }
  };
  const handleKeyDown = useCallback((event: KeyboardEvent<HTMLElement>) => {
    if (!items?.length) {
      return;
    }
    let updatedIndex = activeIndex;
    if (event.key === 'Enter') {
      event.preventDefault();
      if (selectedItem) {
        handleSelected(selectedItem.objectId);
      } else {
        // triggers validation error message
        handleSubmit();
      }
    } else {
      updatedIndex = handleNavKeyDown(event, items.length, activeIndex);
    }
    const item = items[updatedIndex];
    if (['Enter', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) && item) {
      /**
       * Manually track that the url has been updated using searchResult method
       */
      trackAttribute('linkFieldContent', getLinkFieldContent(item.url));
      trackAttribute('linkFieldContentInputMethod', 'searchResult');
      trackAttribute('linkFieldContentInputSource', getDataSource(item, activePlugin));
      dispatch({
        activeIndex: updatedIndex,
        selectedIndex: updatedIndex,
        url: item.url,
        invalidUrl: false,
        hasPreview: true
      });
    }
  }, [items, activeIndex, selectedItem, handleSelected, handleSubmit, trackAttribute, activePlugin]);
  const messages = isActivePlugin ? searchMessages : linkMessages;
  const screenReaderDescriptionId = 'search-recent-links-field-description';
  const linkSearchListId = 'link-picker-search-list';
  const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
  const a11yList = isActivePlugin || isLoadingPlugins ? ({
    role: 'combobox',
    // When a combobox popup is not visible, the element with role combobox has aria-expanded set to false
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded#combobox
    'aria-expanded': !!items?.length,
    'aria-autocomplete': 'list',
    'aria-controls': linkSearchListId,
    'aria-activedescendant': ariaActiveDescendant,
    'aria-describedby': screenReaderDescriptionId
  } as const) : undefined;

  // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
  // as the Aria design pattern for combobox does not work in this case
  // for details: https://a11y-internal.atlassian.net/browse/AK-740
  const screenReaderText = browser().safari && getScreenReaderText(items ?? [], selectedIndex, intl);
  const customSubmitButtonLabel = customMessages?.submitButtonLabel ? customMessages.submitButtonLabel : undefined;
  const errorMessage = invalidUrl ? previewableLinksOnly && !hasPreview ? <FormattedMessage {...formMessages.noEmbedAvailable} values={{
    a: chunk => <LinkUrl target="_blank" href="https://support.atlassian.com/platform-experiences/docs/smart-links-from-jira-and-other-products/">
									{chunk}
								</LinkUrl>
  }} /> : intl.formatMessage(formMessages.linkInvalid) : null;
  return <form data-testid={testIds.linkPicker}
  // Use onSubmitCapture instead of onSubmit so that any possible parent form isn't submitted
  onSubmitCapture={handleSubmit} noValidate={true} className={ax(["_2Zuz6QpE59 _1ZnuxbOhNx _0Of8r2YYwB _1wydGWohXU _24h04i2Njc _3iDTPb61cj"])}>
					<TrackMount />
					{submitOnInputChange && <AutoSubmitOnChange url={url} isSubmitting={isSubmitting} isSelectedItem={isSelectedItem} onSubmit={handleSubmit} onClearInvalidUrl={handleClearInvalidUrl} />}

					{isActivePlugin && <Fragment>
							{screenReaderText && <Announcer ariaLive="assertive" text={screenReaderText} ariaRelevant="additions" delay={250} />}
							<VisuallyHidden id={screenReaderDescriptionId}>
								{customMessages?.linkAriaLabel ? <FormattedMessage {...customMessages.linkAriaLabel} /> : <FormattedMessage {...messages.linkAriaLabel} />}
							</VisuallyHidden>
						</Fragment>}
					<LinkInputField name="url" autoComplete="off" testId={testIds.urlInputField} label={customMessages?.linkLabel ? intl.formatMessage(customMessages.linkLabel) : intl.formatMessage(messages.linkLabel)} placeholder={customMessages?.linkPlaceholder ? intl.formatMessage(customMessages?.linkPlaceholder) : intl.formatMessage(messages.linkPlaceholder)} value={url} autoFocus clearLabel={intl.formatMessage(formMessages.clearLink)} error={errorMessage || additionalError} spotlightTargetName="link-picker-search-field-spotlight-target" aria-readonly={isSubmitting} {...a11yList} onClear={handleUrlClear} onKeyDown={handleKeyDown} onChange={handleChangeUrl} inputRef={mergedRefs} isRequired />
					{!hideDisplayText && <Fragment>
							<DisplayTextInputField autoComplete="off" name="displayText" testId={testIds.textInputField} value={displayText} label={customMessages?.linkTextLabel ? intl.formatMessage(customMessages.linkTextLabel) : intl.formatMessage(linkTextMessages.linkTextLabel)} placeholder={customMessages?.linkTextPlaceholder ? intl.formatMessage(customMessages?.linkTextPlaceholder) : intl.formatMessage(linkTextMessages.linkTextPlaceholder)} clearLabel={intl.formatMessage(linkTextMessages.clearLinkText)} readOnly={isSubmitting} onClear={handleClear} onChange={handleChangeText} helperMessage={intl.formatMessage(customMessages?.linkHelperTextLabel ?? linkTextMessages.linkHelperTextLabel)} />
						</Fragment>}
					{moveSubmitButton && <Box xcss={styles.fullWidthSubmitButton}>
							<LinkPickerSubmitButton isEditing={isEditing} isLoading={isLoadingResults || !!isLoadingPlugins} isSubmitting={isSubmitting} customSubmitButtonLabel={customSubmitButtonLabel} error={error} items={items} queryState={queryState} submitMessageId={submitMessageId} testId={testIds.insertButton} url={url} disableManualUrlInsert={disableManualUrlInsert} />
						</Box>}
					{!!queryState && (isLoadingPlugins || isActivePlugin) && <SearchResults activeTab={activeTab} tabs={tabs} activePlugin={activePlugin} isLoadingResults={isLoadingResults} isLoadingPlugins={isLoadingPlugins} isSubmitting={isSubmitting} linkSearchListId={linkSearchListId} error={error} featureFlags={featureFlags} activeIndex={activeIndex} selectedIndex={selectedIndex} items={items} queryState={queryState} handleKeyDown={handleKeyDown} handleSelected={handleSelected} handleTabChange={handleTabChange} handleSearchListOnChange={handleSearchListOnChange} adaptiveHeight={adaptiveHeight} retry={retry} shouldRenderNoResultsImage={shouldRenderNoResultsImage} />}
					<FormFooter error={error} items={items}
    /** If the results section appears to be loading, impact whether the submit button is disabled */ isLoading={isLoadingResults || !!isLoadingPlugins} isSubmitting={isSubmitting} queryState={queryState} url={url} isEditing={isEditing} onCancel={onCancel} action={pluginAction} customSubmitButtonLabel={customSubmitButtonLabel} submitMessageId={submitMessageId} hideSubmitButton={moveSubmitButton || submitOnInputChange} disableManualUrlInsert={disableManualUrlInsert} className={ax([(!queryState || !plugins?.length) && "_3138425zaO"])} />
				</form>;
}));